import { render, staticRenderFns } from "./CustomSubItem.vue?vue&type=template&id=c505a0f4&scoped=true"
import script from "./CustomSubItem.vue?vue&type=script&lang=js"
export * from "./CustomSubItem.vue?vue&type=script&lang=js"
import style0 from "./CustomSubItem.vue?vue&type=style&index=0&id=c505a0f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c505a0f4",
  null
  
)

export default component.exports